import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Box,
  IconButton,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  Chip,
  CircularProgress,
} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import toastAlert from "./toastAlert";
// import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import {
  FrontendBaseUrl,
  getUrlWithSubdomain,
  getUserLocation,
  post,
} from "../apis/apis";
import SignersDialog from "./SignersDialog";
import { handleDownloadPDFHereTest, saveData } from "./utlis";

const SendEsignModal = ({
  annotations,
  imageUrls,
  open,
  onClose,
  documentName,
  setDocumnetName,
  signers,
  onUpdateSigners,
  onUpdateRecipients,
  emailSubject,
  setEmailSubject,
  emailMessage,
  setEmailMessage,
  file_id,
  user_id,
  uniqIdDoc,
  primaryColorComp,
}) => {
  const [signersDialogOpen, setSignersDialogOpen] = useState(false);
  const [signerToEdit, setSignerToEdit] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [emailSubjectError, setEmailSubjectError] = useState("");
  const [showRecipients, setShowRecipients] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [newRecipient, setNewRecipient] = useState({ email: "", name: "" });
  // Add these states at the top
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [editingRecipient, setEditingRecipient] = useState(null);
  const [isRecipientFormOpen, setIsRecipientFormOpen] = useState(false);
  const [recipientError, setRecipientError] = useState({});

  // Add access code dialog state
  const [accessCodeDialogOpen, setAccessCodeDialogOpen] = useState(false);
  const [selectedSigner, setSelectedSigner] = useState(null);
  const [accessCode, setAccessCode] = useState("");
  //   const [activityLogData, setActivityLogData] = useState([]);
  const getActivityLog = async (file_id) => {
    //console.log('Activity Log ');
    const postData = {
      file_id: file_id,
    };
    const apiData1 = await post("file/getFileActivityLog", postData); // Specify the endpoint you want to call
    console.log("ACTIVITY LOG");

    console.log(apiData1);
    // fileDetail
    if (apiData1.data.length === 0) {
      return null;
    } else {
      //   setActivityLogData(apiData1.data); // Set the state with formatted data
      return apiData1.data;
    }
  };
  const markdocCompleted = async (file_id) => {
    console.log("markdocCompleted");
    const postData = {
      file_id: file_id,
      // position_array: savedCanvasData
      // position_array: filteredTextItems,
    };
    // try {
    const apiData = await post("file/completeDocumentSelfSigned", postData); // Specify the endpoint you want to call
    console.log(apiData);
    if (apiData.error) {
      toastAlert("error", "Something went wrong!");
    } else {
      toastAlert("success", apiData.message);
      // setSelfSign(false);
      setTimeout(() => {
        // const baseUrl = window.location.origin + window.location.pathname;
        let hashedUrl = `${FrontendBaseUrl}home?completed=success`;
        window.location.href = `${hashedUrl}`;
        // window.location.href = "/home?completed=success";
      }, 1000);

      // setStatusData("Completed");
      // fetchAllFiles("Completed");
      // setActive("4");
      // fetchAllCardsDashboard();
    }
  };
  const saveDataSigning = async (filteredTextItems) => {
    // setUnsavedChanges(false);
    // setsaveLoading(true);
    const location = await getUserLocation();

    const postData = {
      file_id: file_id,
      // position_array: savsend-doc-to-esignedCanvasData
      last_change: location.date,
      position_array: filteredTextItems,
    };
    try {
      const apiData = await post("file/saveCanvasDataWithFile_Id", postData); // Specify the endpoint you want to call
      //console.log('Save Data To canvas ');
      console.log("apiData asave ");

      console.log(apiData);
      if (apiData.error) {
        // setsaveLoading(false);
        // setSaveSuccess(false);
      } else {
        // setSaveSuccess(true);
        // setTimeout(() => {
        //   setSaveSuccess(false);
        //   setsaveLoading(false);
        //   setContinueModal(false);
        // download completed
        // handleDownloadPDFHere({
        //   setDownloadPdfLoader,
        //   imageUrls,
        //   textItems,
        //   canvasWidth,
        //   UniqIdDoc,
        //   ActivityLogData,
        //   fileName,
        //   file_id
        // });
        // }, 2000);
        // fetchDataPositions(file_id);
        // UpdateLastChange();
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
      //   setsaveLoading(false);
    }
  };
  const sendToEsignApi = async () => {
    if (!emailSubject || emailSubject.trim() === "") {
      setEmailSubjectError("Subject is required");
      toastAlert("error", "Email subject is required");
      return;
    }
    setEmailSubjectError("");
    if (!emailMessage || emailMessage.trim() === "") {
      toastAlert("error", "Email message is required");
      return;
    }
    // api to update name of file
    // // update_email_content()
    // console.log("textItems");
    // console.log(textItems);
    // // Check for `signer_dropdown` type items with empty or null `options`

    // const specifiedTypes = [
    //   "my_text",
    //   "my_signature",
    //   "my_initials",
    //   "date",
    //   "checkmark",
    //   "highlight",
    //   "stamp",
    // ];

    // // Filter items with the specified types
    // const filteredTextItems = textItems.filter((item) =>
    //   specifiedTypes.includes(item.type)
    // );

    // // Filter items without the specified types
    // const nonSpecifiedTextItems = textItems.filter(
    //   (item) => !specifiedTypes.includes(item.type)
    // );
    // let response_log1 = await getActivityLogUserFiles({
    //   file_id: file_id,
    //   email: user?.email,
    //   event: "Send-for-signing",
    //   description: `${fileName} completed  `,
    //   status: "selfsigned",
    // });
    // // Now you can use `filteredTextItems` wherever you need
    // console.log(filteredTextItems);
    // const user_id = user?.user_id;
    // let ActivityLogDetails = await getActivityLog(file_id);
    // console.log(ActivityLogDetails);
    // setDownloadPdfLoader(false);
    // const downloadPdf = handleDownloadPDFHereTest({
    //   setDownloadPdfLoader,
    //   imageUrls,
    //   textItems: filteredTextItems,
    //   canvasWidth,
    //   UniqIdDoc,
    //   UniqIdDoc,
    //   // ActivityLogData: ActivityLogDetails,
    //   ActivityLogData: response_log1,

    //   fileName,
    //   file_id,
    //   statusData: null,
    //   imageUrlsCount: null,
    //   user_id,
    //   doc_completed: true,
    //   logo_data: logo,
    //   canvasHeight,
    // });
    // //     console.log("error")
    // //     console.log(downloadPdf)

    // //     if(downloadPdf.error===true){
    // setDownloadPdfLoader(false);
    // toastAlert("error","Something went wrong!")
    //     }else{
    //     setDownloadPdfLoader(false)

    //     }
    // await saveDataSigning(nonSpecifiedTextItems);
    // // console.log(textItems)
    //  uncomment  this line to download the pdf
    // await AddSignersData();
    // await AddRecipientsData();
    //console.log(inputValue);
    const kbaRequiredSignersCount = (signers || []).filter((signer) =>
      Boolean(signer?.require_kba || signer?.requireKba)
    ).length;

    // IMPORTANT: Deduct KBA credits first, before any downstream send APIs.
    if (kbaRequiredSignersCount > 0) {
      if (!user_id) {
        toastAlert("error", "User not found for KBA credit deduction.");
        return;
      }

      const kbaRemoveRes = await post("api/kba-credits/remove", {
        user_id,
        amount: kbaRequiredSignersCount,
      });

      if (kbaRemoveRes?.error) {
        toastAlert(
          "error",
          kbaRemoveRes?.message || "Insufficient KBA credits. Please add more."
        );
        return;
      }
    }

    let data = await saveData(file_id, annotations, true);
    console.log("data", data);
    if (data?.error) {
      toastAlert("error", "Something went wrong!");
      return;
    }
    let textItems = data?.formatted_data;
    const cleanedTextItems = textItems.filter(
      (item) =>
        !(
          item.type === "signer_dropdown" &&
          (!item.options || item.options.length === 0)
        )
    );
    console.log("dropdown", cleanedTextItems);
    const location = await getUserLocation();
    let documentNamedata = documentName;

    // Match multiple `.pdf` at the end
    const pdfPattern = /\.pdf(\.pdf)+$/i;

    if (pdfPattern.test(documentName)) {
      // Remove only the last `.pdf`, keeping the first one
      documentNamedata = documentName.replace(/\.pdf$/i, "");
    }

    try {
      const specifiedTypes = [
        "my_text",
        "my_signature",
        "my_initials",
        "date",
        "checkmark",
        "highlight",
        "stamp",
      ];
      const filteredTextItems = cleanedTextItems.filter((item) =>
        specifiedTypes.includes(item.type)
      );
      const nonSpecifiedTextItems = cleanedTextItems.filter(
        (item) => !specifiedTypes.includes(item.type)
      );
      const groupedAnnotations = {};
      filteredTextItems.forEach((item) => {
        const pageNum = item.page_no;
        if (!groupedAnnotations[pageNum]) {
          groupedAnnotations[pageNum] = [];
        }
        groupedAnnotations[pageNum].push(item);
      });

      // 1) Apply/download-style annotation merge first.
      let ActivityLogDetails = await getActivityLog(file_id);
      const setDownloadPdfLoader = true;
      const mergeResult = await handleDownloadPDFHereTest({
        setDownloadPdfLoader,
        imageUrls,
        textItems: groupedAnnotations,
        canvasWidth: "100%",
        UniqIdDoc: uniqIdDoc,
        ActivityLogData: ActivityLogDetails,
        fileName: documentNamedata,
        file_id,
        statusData: null,
        imageUrlsCount: null,
        user_id,
        textBottomPaddingAbs: 3.5,
      });
      if (mergeResult?.error) {
        toastAlert("error", mergeResult?.message || "Failed to apply annotations to PDF.");
        return;
      }
      await saveDataSigning(nonSpecifiedTextItems);

      // 2) Only after merge succeeds, send/update document on backend.
      const recipientsPayload = (recipients || []).map((r) => ({
        name: r.name || "",
        email: (r.email || "").trim().toLowerCase(),
      }));
      const addRecipientRes = await post("file/add-recipient", {
        file_id,
        recipients: recipientsPayload,
      });
      if (addRecipientRes?.error) {
        console.warn(
          "Add Recipients save failed (copy when complete may not work):",
          addRecipientRes.message
        );
      }

      const postData = {
        file_id: file_id,
        email_subject: emailSubject,
        email_message: emailMessage,
        name: documentNamedata,
        location_country: location?.country,
        ip_address: location?.ip,
        location_date: location?.date,
        timezone: location?.timezone,
        region: location?.region,
      };
      const apiData = await post("file/send-doc-to-esign", postData);
      console.log("Update File Controls ");
      console.log(apiData);
      if (apiData.error) {
        toastAlert("error", apiData.message);
        return;
      }

      toastAlert("succes", "Document Send to E-Sign");
      console.log("completed");
      setTimeout(() => {
        let hashedUrl = `${FrontendBaseUrl}home?waitingforOtherstoast=success`;
        window.location.href = `${hashedUrl}`;
      }, 1000);
    } catch (error) {
      console.log("Error fetching data:", error);
      //   setLoadingSendDocument(false);
    }
  };
  const validateAccessCode = (code) => {
    const regex = /^[a-zA-Z0-9]{6}$/;
    return regex.test(code);
  };
  // Add recipient validation
  const validateRecipient = () => {
    const errors = {};
    if (!recipientName.trim()) errors.name = "Name is required";
    if (!recipientEmail.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(recipientEmail)) {
      errors.email = "Invalid email format";
    }
    setRecipientError(errors);
    return Object.keys(errors).length === 0;
  };
  // Add recipient handler (also used for Update)
  const handleAddRecipient = () => {
    if (!validateRecipient()) return;

    // Only enforce "1 recipient" when adding a new one; when editing, we're updating the current recipient
    if (editingRecipient === null && recipients.length >= 1) {
      toastAlert("error", "Only 1 recipient allowed");
      return;
    }

    const newRecipient = {
      id: editingRecipient !== null ? recipients[editingRecipient]?.id : Date.now(),
      name: recipientName,
      email: recipientEmail,
    };

    if (editingRecipient !== null) {
      setRecipients(
        recipients.map((r, i) => (i === editingRecipient ? newRecipient : r))
      );
    } else {
      setRecipients([...recipients, newRecipient]);
    }

    setRecipientName("");
    setRecipientEmail("");
    setEditingRecipient(null);
    setIsRecipientFormOpen(false);
  };

  // Edit recipient handler
  const handleEditRecipient = (index) => {
    const recipient = recipients[index];
    setRecipientName(recipient.name);
    setRecipientEmail(recipient.email);
    setEditingRecipient(index);
    setIsRecipientFormOpen(true);
  };

  // Delete recipient handler
  const handleDeleteRecipient = (index) => {
    setRecipients(recipients.filter((_, i) => i !== index));
  };

  // Open recipient form handler
  const handleOpenRecipientForm = () => {
    setRecipientName("");
    setRecipientEmail("");
    setEditingRecipient(null);
    setIsRecipientFormOpen(true);
  };

  // Close recipient form handler
  const handleCloseRecipientForm = () => {
    setRecipientName("");
    setRecipientEmail("");
    setEditingRecipient(null);
    setIsRecipientFormOpen(false);
    setRecipientError({});
  };

  const renderSigners = () => (
    <List sx={{ p: 0 }}>
      {signers.map((signer, index) => (
        <ListItem
          key={signer.id || `signer-${index}`}
          disablePadding
          sx={{
            mb: 1.5,
            display: "flex",
            alignItems: "flex-start",
            p: 1.5,
            borderRadius: 1.5,
            border: "1px solid rgba(0,0,0,0.08)",
            backgroundColor: "rgba(0,0,0,0.02)",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.04)",
              borderColor: "rgba(0,0,0,0.12)",
            },
          }}
        >
          <Box
            sx={{
              backgroundColor: signer.color || "#21b3e8",
              width: 40,
              height: 40,
              borderRadius: "50%",
              flexShrink: 0,
              mr: 1.5,
            }}
          />
          <ListItemText
            primary={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Typography variant="caption" sx={{ color: "rgba(0,0,0,0.5)", fontWeight: 600 }}>
                  #{signer.order_id}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, color: "rgba(0,0,0,0.9)" }}>
                  {signer.name || signer.email}
                </Typography>
              </Box>
            }
            secondary={
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="body2" sx={{ color: "rgba(0,0,0,0.6)" }}>
                  {signer.email}
                </Typography>
                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", mt: 1 }}>
                  <Chip
                    label={`Access Code: ${signer.access_code || "Not set"}`}
                    size="small"
                    sx={{
                      height: 22,
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      backgroundColor: signer.access_code ? "rgba(44, 62, 80, 0.08)" : "rgba(0,0,0,0.06)",
                      color: signer.access_code ? "#2c3e50" : "rgba(0,0,0,0.5)",
                      "& .MuiChip-label": { px: 1.25 },
                    }}
                  />
                  {(signer.require_kba || signer.requireKba) && (
                    <Chip
                      label="KBA Required"
                      size="small"
                      sx={{
                        height: 22,
                        fontSize: "0.75rem",
                        fontWeight: 500,
                        backgroundColor: "rgba(40, 199, 111, 0.12)",
                        color: "#28c76f",
                        "& .MuiChip-label": { px: 1.25 },
                      }}
                    />
                  )}
                </Box>
              </Box>
            }
          />
          <IconButton
            size="small"
            onClick={() => {
              setSignerToEdit({ signer, index });
              setSignersDialogOpen(true);
            }}
            sx={{
              ml: "auto",
              flexShrink: 0,
              backgroundColor: "rgba(0,0,0,0.04)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.08)" },
              borderRadius: 1,
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </ListItem>
      ))}
    </List>
  );
  const RecipientForm = () => (
    <Box sx={{ mt: 2, p: 2, backgroundColor: "rgba(0,0,0,0.03)", borderRadius: 1.5, border: "1px solid rgba(0,0,0,0.06)" }}>
      <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: "rgba(0,0,0,0.8)" }}>
        {editingRecipient !== null ? "Edit Recipient" : "Add Recipient"}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <TextField
          fullWidth
          label="Name"
          size="small"
          value={recipientName}
          onChange={(e) => setRecipientName(e.target.value)}
          error={!!recipientError.name}
          helperText={recipientError.name}
          variant="outlined"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, backgroundColor: "white" } }}
        />
        <TextField
          fullWidth
          label="Email"
          size="small"
          type="email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
          error={!!recipientError.email}
          helperText={recipientError.email}
          variant="outlined"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, backgroundColor: "white" } }}
        />
        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 0.5 }}>
          <Button onClick={handleCloseRecipientForm} sx={{ textTransform: "none", fontWeight: 600 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddRecipient}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 1.5,
              px: 2,
              backgroundColor: primaryColorComp ?? "#21b3e8",
              "&:hover": { backgroundColor: primaryColorComp ?? "#00bcff" },
            }}
          >
            {editingRecipient !== null ? "Update" : "Add"} Recipient
          </Button>
        </Box>
      </Box>
    </Box>
  );
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: "70vh",
            maxHeight: "90vh",
            borderRadius: 2,
            boxShadow: "0 24px 48px rgba(0,0,0,0.12)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
            px: 3,
            flexShrink: 0,
            backgroundColor: "white",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
          }}
        >
          <Typography variant="h6" fontWeight={600} sx={{ fontSize: "1.25rem", letterSpacing: "-0.01em" }}>
            Send Document for E-Signing
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" }, borderRadius: 1 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 0, flex: 1, minHeight: 0, overflow: "auto" }}>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, minHeight: "100%" }}>
            {/* Left Section - Document Details */}
            <Box
              sx={{
                flex: 1,
                p: 3,
                borderRight: { md: "1px solid rgba(0,0,0,0.08)" },
                borderBottom: { xs: "1px solid rgba(0,0,0,0.08)", md: "none" },
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 2.5, fontWeight: 600, color: "rgba(0,0,0,0.85)", letterSpacing: "-0.01em" }}>
                Document Details
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                <Box>
                  <Typography variant="caption" sx={{ display: "block", mb: 0.75, color: "rgba(0,0,0,0.6)", fontWeight: 500 }}>
                    Document Name
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={documentName}
                    onChange={(e) => setDocumnetName(e.target.value)}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": { borderRadius: 1.5, backgroundColor: "rgba(0,0,0,0.02)" },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",
                        backgroundColor: "rgba(0,0,0,0.04)",
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography variant="caption" sx={{ display: "block", mb: 0.75, color: "rgba(0,0,0,0.6)", fontWeight: 500 }}>
                    Email Subject
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={emailSubject}
                    error={!emailSubject?.trim() || Boolean(emailSubjectError)}
                    helperText={
                      !emailSubject?.trim() || emailSubjectError
                        ? emailSubjectError || "Subject is required"
                        : ""
                    }
                    onChange={(e) => {
                      setEmailSubject(e.target.value);
                      if (e.target.value.trim()) setEmailSubjectError("");
                    }}
                    onBlur={() => {
                      if (!emailSubject?.trim()) {
                        setEmailSubjectError("Subject is required");
                      }
                    }}
                    variant="outlined"
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, backgroundColor: "rgba(0,0,0,0.02)" } }}
                  />
                </Box>

                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, color: "rgba(0,0,0,0.85)", letterSpacing: "-0.01em" }}>
                    Signers
                  </Typography>
                  {renderSigners()}

                  {/* Recipients Section */}
                  <Box sx={{ mt: 3, pt: 2.5, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showRecipients}
                          onChange={(e) => setShowRecipients(e.target.checked)}
                          sx={{
                            "&.Mui-checked": {
                              color: primaryColorComp ?? "#21b3e8",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "rgba(0,0,0,0.85)" }}>
                          Add Recipient
                        </Typography>
                      }
                    />
                    <Typography variant="caption" sx={{ display: "block", ml: 4, mt: 0.25, color: "rgba(0,0,0,0.55)" }}>
                      Receives a copy when complete
                    </Typography>
                    {showRecipients && (recipients.length === 0 || editingRecipient !== null) ? RecipientForm() : null}
                    {showRecipients && recipients.length > 0 && (
                      <Box sx={{ mt: 2 }}>
                        <List disablePadding>
                          {recipients.map((recipient, index) => (
                            <ListItem
                              key={index}
                              disablePadding
                              sx={{
                                py: 1,
                                px: 1.5,
                                borderRadius: 1,
                                border: "1px solid rgba(0,0,0,0.08)",
                                mb: 1,
                                backgroundColor: "rgba(0,0,0,0.02)",
                              }}
                              secondaryAction={
                                <Box sx={{ display: "flex", gap: 0.25 }}>
                                  <IconButton size="small" onClick={() => handleEditRecipient(index)} sx={{ "&:hover": { backgroundColor: "rgba(0,0,0,0.06)" }, borderRadius: 1 }}>
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton size="small" onClick={() => handleDeleteRecipient(index)} sx={{ "&:hover": { backgroundColor: "rgba(0,0,0,0.06)" }, borderRadius: 1 }}>
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              }
                            >
                              <ListItemText
                                primary={<Typography variant="body2" fontWeight={600}>{recipient.name}</Typography>}
                                secondary={recipient.email}
                                sx={{ "& .MuiListItemText-secondary": { fontSize: "0.8rem", color: "rgba(0,0,0,0.6)" } }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Right Section - Email Message */}
            <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
              <Typography variant="caption" sx={{ display: "block", mb: 0.75, color: "rgba(0,0,0,0.6)", fontWeight: 500 }}>
                Email Message
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={12}
                value={emailMessage}
                onChange={(e) => setEmailMessage(e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: 1.5, backgroundColor: "rgba(0,0,0,0.02)", alignItems: "flex-start" },
                }}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            flexShrink: 0,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            px: 3,
            py: 2,
            m: 0,
            borderTop: "1px solid rgba(0,0,0,0.08)",
            backgroundColor: "rgba(0,0,0,0.02)",
          }}
        >
          <Button
            disabled={isSending}
            onClick={async () => {
              if (!emailSubject?.trim()) {
                setEmailSubjectError("Subject is required");
                return;
              }
              setIsSending(true);
              try {
                await sendToEsignApi();
              } catch (error) {
                console.error("Error sending document:", error);
                toastAlert("error", "Failed to send document");
              } finally {
                setIsSending(false);
              }
            }}
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.9375rem",
              borderRadius: 1.5,
              px: 4,
              py: 1.25,
              boxShadow: "none",
              backgroundColor: primaryColorComp ?? "#21b3e8",
              "&:hover": {
                backgroundColor: primaryColorComp ?? "#1656b3",
                boxShadow: "none",
              },
            }}
          >
            {isSending ? (
              <>
                <CircularProgress size={22} sx={{ color: "white", mr: 1.5 }} />
                Sending…
              </>
            ) : (
              "Send"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      <SignersDialog
        primaryColorComp={primaryColorComp}
        open={signersDialogOpen}
        onClose={() => {
          setSignersDialogOpen(false);
          setSignerToEdit(null);
        }}
        signers={signers}
        setSigners={onUpdateSigners}
        signerToEdit={signerToEdit}
        file_id={file_id} // Make sure to pass file_id as prop
      />
    </>
  );
};

export default SendEsignModal;
